class DevicePostureCheckDatatable {
	constructor(){
		let organizationID = new URLSearchParams(window.location.search).get('organizationID');
		this.datatable = this.init('#device-posture-check-datatable', organizationID);
		this.organizationID = organizationID;
		this.initActions(organizationID);
	}
	init(el, organizationID){
		let thisClass = this;
		const datatable = $(el).DataTable({
			searchDelay: 400,
			processing: true,
			serverSide: true,
			stateSave: false,
			info: true,
			paging: true,
			ajax: {
				url: '?do=getDevicePostureCheck',
				type: 'POST',
				data: {
					organizationID: organizationID
				}
			},
			language: {
				emptyTable: "No data found"
			},
			dom:
				"<'table-responsive'tr>" +
				"<'row'" +
				"<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
				"<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
				">",
			drawCallback: function(settings) {
				// Init all popovers after datatable draw
				const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
				popoverTriggerList.map(function (popoverTriggerEl) {
					new bootstrap.Popover(popoverTriggerEl);
				});
				// init page length select
				$('select[name=device-posture-check-datatable_length]').select2({minimumResultsForSearch: -1});
			},
			columns: [
				{
					data: 'uuid',
					title: 'Policy',
					sortable: true,
					className: 'min-w-120px',
					render: function (data, type, row) {
						return '<div class="d-flex align-items-center">' +
							'       <div class="symbol symbol-40px border ga-border-primary-300 text-center min-h-40px min-w-40px me-3">' +
							'           <div class="symbol-label bg-light-primary border border-2 border-white fs-3 text-primary">' +
							(!row['isDefault'] ? row['name'].substring(0, 1)
								: '<img src="/media/goodaccess/logo/goodaccess-mobile.svg" class="mw-30px" alt="Logo"/>')+
							'           </div>'+
							'       </div>'+
							'       <div class="d-flex justify-content-start flex-column">' +
							'           <div id="'+row['uuid']+'" class="d-flex align-items-center"><span class="fw-bold text-nowrap text-decoration-underline-ga primary text-primary mb-1 fs-6 '+ (row['edit'] ? 'edit-device-posture-check' : '') +'" data-name="'+row['name']+'">'+row['name']+'</span></div>' +
							(row['shortDescription'] ?
								'           <div class="d-flex align-items-center">' +
								'               <span class="fw-semibold d-block fs-7 ga-text-primary-800" '+(row['description'] !== row['shortDescription'] ? 'data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="'+row['description']+'"' : '')+'>'+row['shortDescription']+'</span>' +
								'           </div>' : '') +
							'       </div>' +
							'   </div>';
					}
				},
				{
					data: 'restrictions',
					title: 'OS Restrictions',
					className: 'min-w-100px',
					sortable: false,
					render: function (data, type, row) {
						let html = '<div class="symbol-group symbol-hover flex-nowrap">';
						html += thisClass.getSymbolHtmlFromDevicePoster(row['windowsAllowed'], row['Windows'], 'Windows');
						html += thisClass.getSymbolHtmlFromDevicePoster(row['linuxAllowed'], row['Linux'], 'Linux');
						html += thisClass.getSymbolHtmlFromDevicePoster(row['macOSAllowed'], row['macOS'], 'macOS');
						html += thisClass.getSymbolHtmlFromDevicePoster(row['iPadOSAllowed'], row['iPadOS'], 'iPadOS');
						html += thisClass.getSymbolHtmlFromDevicePoster(row['iOSAllowed'], row['iOS'], 'iOS');
						html += thisClass.getSymbolHtmlFromDevicePoster(row['androidAllowed'], row['Android'], 'Android');
						return html+'</div>';
					}
				},
				{
					data: 'members',
					title: 'Members',
					sortable: false,
					render: function (data, type, row) {
						if(row['allMembers']){
							return 'All Members';
						}

                        let html = '<div class="symbol-group symbol-hover flex-nowrap">';
                        if(row['groups']){
                            for(let i = 0; i < row['groups'].length; i++){
                                if (i < 3) {
                                    html += new GroupInfoGenerator().generateMemberIconView(row['groups'][i]['name'], row['groups'][i]['edit'], row['groups'][i]['uuid'], row['groups'][i]['members'].length);
                                } else {
                                    let members = row['members'] ? row['members'].length : 0;
                                    html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="'+row['uuid']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['groups'].length - 3)+' more Groups'+(row['members'] ? ', '+row['members'].length+' more Members' : '')+'</div>">' +
                                        '        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder '+ (row['edit'] ? 'edit-device-posture-check' : '') +'">+'+(row['groups'].length - 3 + members)+'</div>'+
                                        '     </div>';
                                    break;
                                }
                            }

							if(row['groups'] && row['groups'].length === 3 && row['members'] && row['members'].length > 1){
								html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="'+row['uuid']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['members'].length)+' more Members</div>">' +
									'        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder '+ (row['edit'] ? 'edit-device-posture-check' : '') +'">+'+(row['members'].length)+'</div>'+
									'     </div>';
								return html;
							}
						}

						if((row['groups'] && row['groups'].length < 4 && row['members']) || (!row['groups'] && row['members'] && row['members'].length > 0)){
							for (let i = 0; i < row['members'].length; i++) {
								let avatarUrl = '/media/goodaccess/avatars/svg/device.svg';
								if (row['members'][i]['avatarID'] || row['members'][i]['isIdp']) {
									avatarUrl = '/media/goodaccess/avatars/svg/Icon with face-' + row['members'][i]['avatarID'] + '.svg';
								}

								if ((row['groups'] && row['groups'].length + i < 3) || (!row['groups'] && i < 3)) {
									if (row['members'][i]['password'] || row['members'][i]['isIdp']) {
										html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300"` + (row['members'][i]['edit'] ? ' id="'+row['members'][i]['uuid']+'"' : '') + `>` +
											(row['members'][i]['edit'] ? '<div class="edit-member">' : '') +
											`        <div class="symbol-label bg-light-primary border border-2 border-white`+(row['members'][i]['isBlocked'] === 1 ? ' filter-grayscale' : '')+(!row['members'][i]['hasGateway'] ? ' opacity-50' : '')+ `" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="`+ (!row['members'][i]['isIdp'] && !row['members'][i]['avatarID'] ? `<div class='fw-bold text-center'>` + row['members'][i]['username'] + (row['members'][i]['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(row['members'][i]['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['members'][i]['managerRole']+`</span>` : ``)+(row['members'][i]['meBadge'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Me</span>` : ``) + `</div>` : `<div class='fw-bold text-center'>` + row['members'][i]['name'] + (row['members'][i]['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(row['members'][i]['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['members'][i]['managerRole']+`</span>` : ``)+(row['members'][i]['meBadge'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Me</span>` : ``) + `</div><div class='fw-bold text-center'>` + row['members'][i]['username'] + `</div>`) +`<div class='text-center small'>`+new IdpBadgesGenerator().generateText(row['members'][i]['idps'])+`</div>">`+
											'             <img alt="avatar" class="h-40px" src="' + avatarUrl + '"/>' +
											'        </div>' +
											(row['members'][i]['edit'] ? '</div>' : '') +
											(!row['members'][i]['hasGateway'] ? '<span class="symbol-badge badge badge-circle bg-warning start-85 top-85 w-15px h-15px fs-7 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>This Member is not assigned to any Gateway, so it does not have access to the perimeter</div>">!</span>' : '') +
											(row['members'][i]['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
											(row['members'][i]['connected'] ? '<span class="symbol-badge badge badge-circle bg-success start-85 top-85 w-15px h-15px" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>connected</div>"></span>' : '') +
											'     </div>';
									} else {
										html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300">` +
											`        <div class="symbol-label bg-light-primary border border-2 border-white`+(row['members'][i]['isBlocked'] === 1 ? ' filter-grayscale' : '')+(!row['members'][i]['hasGateway'] ? ' opacity-50' : '')+`" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="`+ (!row['members'][i]['isIdp'] && !row['members'][i]['avatarID'] ? `<div class='fw-bold text-center'>` + row['members'][i]['username'] + (row['members'][i]['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(row['members'][i]['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['members'][i]['managerRole']+`</span>` : ``)+(row['members'][i]['meBadge'] ? `<span class="badge badge-light-danger badge-sm ms-2 align-center">Me</span>` : ``) + `</div>` : `<div class='fw-bold text-center'>` + row['members'][i]['name'] + (row['members'][i]['isBlocked'] ? ' (blocked)' : '') + (row['members'][i]['connected'] ? ' (connected)' : '') + `</div><div class='fw-bold text-center'>` + row['members'][i]['username'] + `</div>`) +`<div class='text-center small'>`+new IdpBadgesGenerator().generateText(row['members'][i]['idps'])+`</div>">`+
											'             <i class="fa-solid fa-user-clock fs-1 '+(row['members'][i]['isBlocked'] === 1 ? 'text-grey-700' : '')+'"></i>'+
											'        </div>' +
											(!row['members'][i]['hasGateway'] ? '<span class="symbol-badge badge badge-circle bg-warning start-85 top-85 w-15px h-15px fs-7 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>This Member is not assigned to any Gateway, so it does not have access to the perimeter</div>">!</span>' : '') +
											(row['members'][i]['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
											'     </div>';
									}
								} else {
									html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="'+row['uuid']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['members'].length - (row['groups'] ? (3 - row['groups'].length) : 3))+' more members</div>">' +
										'        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder '+ (row['edit'] ? 'edit-device-posture-check' : '') +'">+'+(row['members'].length - (row['groups'] ? (3 - row['groups'].length) : 3))+'</div>'+
										'     </div>';
									break;
								}
							}
						}

						return html+'</div>';
					}
				},
				{
					data: 'action',
					title: 'On Failure',
					sortable: false,
					render: function (data, type, row) {
						if(row['denyAccess']){
							return 'Deny access & make a log entry';
						}
						return 'Make a log entry';
					}
				},
				{
					data: null,
					title: 'Action',
					sortable: false,
					render: function (data, type, row) {
						let isEnabled = 'checked';
						let enabledText = 'Enabled';
						if(!row['isEnabled']){
							isEnabled = '';
							enabledText = 'Disabled';
						}

						let html = '<div class="datatable-action d-flex" id="'+row['uuid']+'">';
						if (row['edit']) {
							html +=
								'       <div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-device-posture-check" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Edit" data-cy="edit-dpc-btn">'+
								'           <span class="svg-icon svg-icon-3">' +
								'               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
								'                   <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>\n' +
								'                   <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>\n' +
								'               </svg>' +
								'           </span>' +
								'       </div>'+
								'       <div class="btn btn-icon btn-bg-light btn-sm me-2 '+ (!row['isDefault'] ? 'btn-active-color-primary delete-device-posture-check cursor-pointer' : 'cursor-not-allowed') +'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-cy="delete-dpc-btn" data-bs-content="'+ (!row['isDefault'] ? 'Delete' : '<div class=\'text-center\'>Default security policy cannot be deleted.</div>') +'">'+
								'            <span class="svg-icon svg-icon-3">' +
								'                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
								'                      <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
								'                      <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
								'                      <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
								'                 </svg>' +
								'             </span>' +
								'         </div>'+
								'       <label class="form-check form-switch form-check-custom form-check-solid cursor-pointer">\n' +
								'           <input class="form-check-input enable-device-posture-check cursor-pointer" data-cy="enable-dpc-btn" data-name="'+row['name']+'" type="checkbox" value="1" '+isEnabled+'/>\n' +
								'           <span class="form-check-label fw-semibold text-muted">\n' +
								'               <div class="spinner-border spinner-border-sm d-none" role="status">\n' +
								'                   <span class="visually-hidden">Loading...</span>' +
								'               </div>' +
								'               <span class="enabled-text">'+ enabledText +'</span>'+
								'           </span>' +
								'       </label>';
						}
						return html+'</div>';
					}
				}
			]
		}).on('init.dt', function () {
			if(datatable.page.info().recordsTotal === 0){
				$('#device-posture-check-datatable_wrapper').hide();
				$('#device-posture-check-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
			}
		});
		// Add delay to datatable search
		new DatatableSearchDelay(datatable, '.main-datatable [data-kt-docs-table-filter=search]');
		return datatable;
	}
	getSymbolHtmlFromDevicePoster(isAllowed, restrictionsArr, osName){
		function trimText(text) {
			if (text.length <= 20) {
				return text;
			} else {
				return text.substring(0, 20)+'...';
			}
		}

		let tooltipHtml = '';
		if(!isAllowed){
			tooltipHtml += '<div class="text-center">Not allowed</div><div class="separator my-1"></div>';
		} else if(restrictionsArr) {
			if(restrictionsArr['supportedOSVersion']){
				tooltipHtml += '<div>Supported OS versions only</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['supportedAppVersion']){
				tooltipHtml += '<div>Supported Client App versions only</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['lockScreenEnabled']){
				tooltipHtml += '<div>Lockscreen with authentication</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['diskEncryptionEnabled']){
				if(restrictionsArr['diskEncryptionPath']){
					tooltipHtml += '<div>Disk encryption enabled</div><ul class="mb-0"><li>Path: '+trimText(restrictionsArr['diskEncryptionPath'])+'</li></ul><div class="separator my-1"></div>';
				} else {
					tooltipHtml += '<div>Disk encryption enabled</div><div class="separator my-1"></div>';
				}
			}
			if(restrictionsArr['runningAv']){
				tooltipHtml += '<div>Running antivirus</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['updatedAv']){
				tooltipHtml += '<div>Updated antivirus</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['firewallEnabled']){
				tooltipHtml += '<div>Firewall enabled</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['debugModeOff']){
				tooltipHtml += '<div>Debug mode off</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['emulatorNotAllowed']){
				tooltipHtml += '<div>Emulator not allowed</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['biometricsEnabled']){
				tooltipHtml += '<div>Biometrics enabled</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['enclave']){
				tooltipHtml += '<div>Trusted Execution Environment (TEE) available</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['strongbox']){
				tooltipHtml += '<div>Strongbox available</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['rootedNotAllowed']){
				tooltipHtml += '<div>Rooted device is not allowed</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['registryKey']){
				tooltipHtml += '<div>Registry key</div><ul class="mb-0">';
				for(let registry of restrictionsArr['registryKey']){
					tooltipHtml += '<li>'+trimText(registry['path'])+'</li><ul class="mb-0"><li>'+trimText(registry['key'])+' '+registry['comparator']+' '+trimText(registry['value'])+'</li></ul>';
				}
				tooltipHtml += '</ul><div class="separator my-1"></div>';
			}
			if(restrictionsArr['fileLocation']){
				tooltipHtml += '<div>File in specific location</div><ul class="mb-0">';
				for(let file of restrictionsArr['fileLocation']){
					tooltipHtml += '<li>'+trimText(file['name'])+'</li>';
				}
				tooltipHtml += '</ul><div class="separator my-1"></div>';
			}
			if(restrictionsArr['processRunning']){
				tooltipHtml += '<div>Running process</div><ul class="mb-0">';
				for(let process of restrictionsArr['processRunning']){
					tooltipHtml += '<li>'+trimText(process['name'])+'</li>';
				}
				tooltipHtml += '</ul><div class="separator my-1"></div>';
			}
			if(restrictionsArr['serviceRunning']){
				tooltipHtml += '<div>Running service</div><ul class="mb-0">';
				for(let service of restrictionsArr['serviceRunning']){
					tooltipHtml += '<li>'+trimText(service['name'])+'</li>';
				}
				tooltipHtml += '</ul><div class="separator my-1"></div>';
			}
			if(restrictionsArr['domain']){
				tooltipHtml += '<div>Part of a domain</div><ul class="mb-0">';
				tooltipHtml += '<li>'+trimText(restrictionsArr['domain'])+'</li>';
				tooltipHtml += '</ul><div class="separator my-1"></div>';
			}
			if(restrictionsArr['osVersion'] && restrictionsArr['osVersionComparator']){
				tooltipHtml += '<div>OS version '+restrictionsArr['osVersionComparator']+' '+restrictionsArr['osVersion']+'</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['kernelVersion'] && restrictionsArr['kernelVersionComparator']){
				tooltipHtml += '<div>Kernel version '+restrictionsArr['kernelVersionComparator']+' '+restrictionsArr['kernelVersion']+'</div><div class="separator my-1"></div>';
			}
			if(restrictionsArr['distribution']){
				tooltipHtml += '<div>Allowed distributions</div><ul class="mb-0">';
				for(let distribution of restrictionsArr['distribution']){
					tooltipHtml += '<li>'+trimText(distribution)+'</li>';
				}
				tooltipHtml += '</ul><div class="separator my-1"></div>';
			}
		} else {
			tooltipHtml += '<div class="text-center">Allowed without restrictions</div><div class="separator my-1"></div>';
		}
		return `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300">` +
			`        <div class="symbol-label bg-light-primary border border-2 border-white cursor-help `+(!isAllowed ? 'filter-grayscale' : '')+`" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content='`+tooltipHtml.substring(0, tooltipHtml.length - 34)+`'>` +
			'             <img alt="avatar" class="h-40px" src="/media/goodaccess/icons/os/'+osName+'.svg"/>' +
			'        </div>' +
			'     </div>';
	}
	initActions(organizationID){
		const thisClass = this;
		$(document).on('change', '.enable-device-posture-check', function(e) {
			let thisElement = this;
			let newText = 'Disabled';
			if (e.target.checked) {
				newText = 'Enabled';
			}
			let devicePostureCheckName = $(thisElement).attr('data-name');
			let devicePostureCheckID = $(this).parent().parent()[0].id;
			Swal.fire({
				html: `<span class="text-center text-primary">`+(devicePostureCheckName !== undefined ? `<b>`+devicePostureCheckName+`</b> ` : `Device Posture Check `)+`is going to be `+newText.toLowerCase()+`!</span>`,
				icon: "warning",
				iconColor: "#FF5206",
				buttonsStyling: false,
				reverseButtons: true,
				showCancelButton: true,
				confirmButtonText: "Yes, "+(e.target.checked ? 'enable' : 'disable')+"!",
				customClass: {
					confirmButton: "btn btn-danger mt-0",
					cancelButton: 'btn btn-light-primary mt-0',
				},
			}).then(function(result){
				if (result.value) {
					$(thisElement).prop('disabled', true);
					$(thisElement).parent().find('.spinner-border').removeClass('d-none');
					$.ajax({
						url:  '?do=changeDevicePostureCheckStatus',
						type: 'POST',
						dataType: '',
						data: {
							isEnable: e.target.checked ? 1 : 0,
							devicePostureCheckID: devicePostureCheckID,
							organizationID: thisClass.organizationID
						}
					}).done(function(data) {
						let status = 'disabled';
						if(data['isEnabled'] === '1') {
							status = 'enabled';
						}
						$(thisElement).parent().find('.enabled-text').text(newText);
						$(thisElement).parent().find('.spinner-border').addClass('d-none');
						$(thisElement).prop('disabled', false);
						toastr.success((devicePostureCheckName !== undefined ? devicePostureCheckName : 'Device Posture Check')+' has been successfully '+status+'!');
					});
				} else {
					e.target.checked = !e.target.checked;
				}
			});
		});
		$(document).on('click','#device-posture-check-datatable .delete-device-posture-check',function(e){
			let devicePostureCheckID = $(this).parent()[0].id;
			let devicePostureCheckName = '';
			devicePostureCheckName = $(this).closest('tr').find('span[data-name]').attr('data-name');
			Swal.fire({
				html: `<span class="text-center text-primary">Device Posture Check `+(devicePostureCheckName !== undefined ? `<b>`+devicePostureCheckName+`</b> ` : ``)+`is going to be completely deleted!</span>`,
				icon: "warning",
				iconColor: "#FF5206",
				buttonsStyling: false,
				reverseButtons: true,
				showCancelButton: true,
				confirmButtonText: "Yes, delete!",
				customClass: {
					confirmButton: "btn btn-danger mt-0",
					cancelButton: 'btn btn-light-primary mt-0',
				},
				showLoaderOnConfirm: true,
				returnFocus: false,
				preConfirm: () => {
					return fetch('/device-posture-check?do=removeDevicePostureCheck&organizationID='+organizationID+'&devicePostureCheckID='+devicePostureCheckID)
						.then(response => {
							if (!response.ok) {
								throw new Error(response.statusText)
							}
							return response.json();
						}).catch(error => {
							Swal.showValidationMessage(`Request failed: ${error}`)
						});
				},
				allowOutsideClick: () => !Swal.isLoading(),
				allowEscapeKey: () => !Swal.isLoading()
			}).then((result) => {
				if (result.isConfirmed) {
					if(result.value === 'deleted') {
						toastr.success('Device Posture Check has been deleted.');
						let editDevicePostureCheckModal = document.getElementById('edit_device_posture_check_modal');
						if(editDevicePostureCheckModal){
							bootstrap.Modal.getOrCreateInstance(editDevicePostureCheckModal).hide();
						}
						thisClass.datatable.ajax.reload();

						let numberOfDpcElement = $(".number-of-dpc");
						if(numberOfDpcElement){
							numberOfDpcElement.text(numberOfDpcElement.text() - 1);
						}
					} else if(result.value === 'defaultSecurityPolicy'){
						toastr.error('Default security policy cannot be deleted.');
					} else {
						toastr.error('Unexpected error occurred. Please try it again later.');
					}
				}
			});
		});
	}
}
window.DevicePostureCheckDatatable = DevicePostureCheckDatatable;